import { FontDefinition } from 'editor/src/store/fonts/types';
import uploadedFontToFontDefinition from 'editor/src/store/fonts/utils/uploadedFontToFontDefinition';
import { RootState } from 'editor/src/store/index';

function getFontDefinition(state: RootState, fontFamily: string): FontDefinition | undefined {
  const standard = state.fonts.availableFonts.find((font) => font.metadata.fontFile === fontFamily);
  if (standard) {
    return standard;
  }

  const uploaded = state.fonts.uploadedFonts.find((font) => font.fontFile === fontFamily);
  if (uploaded) {
    const fontDef = uploadedFontToFontDefinition(uploaded);
    if (uploaded.loadingStatus !== undefined) {
      fontDef.status = uploaded.loadingStatus;
    }
    return fontDef;
  }

  return undefined;
}

export default getFontDefinition;
